import axios from 'axios';
import { ROUTES } from '@/constants';
import { ax } from '@/utils';

const state = {
    token: null,
    isLoggedIn: false
};

const getters = {
    token: state => state.token,
    isLoggedIn: state => state.isLoggedIn,
};

/**********				actions				**********/
const actions = {
    login({ commit }, {email, password}) {
        return ax
            .post(ROUTES.LOGIN(), {email, password}, {headers: {'content-type': 'application/json'}})
            .then(res => {
                commit('STORE_TOKEN', res.data.auth_token);
                return res;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },
    logout({commit}) {
        localStorage.removeItem('selectedEnv');
        commit('REMOVE_TOKEN');
        window.location.href = '/login';
    },
    register(context, user) {
        return axios.post(ROUTES.REGISTER(), user);
    },
    init({ getters, commit }) {
        var token = getters.token;
        if (token == null) token = localStorage.getItem('token');
        commit('STORE_TOKEN', token);
        return token;
    },
    removeToken({commit}) {
        commit('STORE_TOKEN', null);
    },
    forgotten(_, email) {
        const url = process.env.VUE_APP_PUBLIC;
        return ax
            .post(ROUTES.FORGOTTEN(url), {'email': email})
            .catch(error => {
                return Promise.reject(error);
            });
    },
    verifyForgottenToken(_, token) {
        return ax
            .get(ROUTES.FORGOTTEN_TOKEN(token))
            .catch(error => {
                return Promise.reject(error);
            });
    },
    resetPassword(_, datas) {
        return ax
            .put(ROUTES.RESET_PASSWORD(), datas)
            .catch(error => {
                return Promise.reject(error);
            });
    },
};

/**********				mutations				**********/

const mutations = {
    STORE_TOKEN(state, token) {
        state.token = token;
        if (token == null) {
            state.isLoggedIn = false;
            localStorage.removeItem('token');
        } else {
            state.isLoggedIn = true;
            localStorage.setItem('token', token);
        }
    },
    REMOVE_TOKEN(state) {
        state.token = null;
        state.isLoggedIn = false;
        localStorage.removeItem('token');
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
